import { createReducer, on } from "@ngrx/store";
import { UserState } from "./user-state";
import { UserActions } from "./user.actions";

export const initialState: UserState = {
  licenses: [],
  isRetrieving: false,
  isInitialized: false,
};

export const userReducer = createReducer(
  initialState,
  on(UserActions.saveLicenses, (_, { licenses }) => {
    return {
      licenses: licenses,
      isRetrieving: false,
      isInitialized: true
    };
  }),
  on(UserActions.startRetrieving, (state) => {
    return {
      licenses: [],
      isRetrieving: true,
      isInitialized: state.isInitialized
    };
  }),
  on(UserActions.errorRetrieving, (_) => {
    return {
      licenses: [],
      isRetrieving: false,
      isInitialized: true
    };
  })
);
